import {
  addDays,
  endOfMonth,
  endOfWeek,
  format,
  parseISO,
  startOfMonth,
  startOfWeek,
} from 'date-fns'

export type ShiftViewMode = 'daily' | 'weekly' | 'monthly'

/** Returns ISO yyyy-MM-dd start/end strings for the focused date in the given view mode. */
export function getDateRange(
  viewMode: ShiftViewMode,
  focusedDate: Date
): { startDate: string; endDate: string } {
  const start =
    viewMode === 'daily'
      ? focusedDate
      : viewMode === 'weekly'
        ? startOfWeek(focusedDate, { weekStartsOn: 1 })
        : startOfMonth(focusedDate)
  const end =
    viewMode === 'daily'
      ? focusedDate
      : viewMode === 'weekly'
        ? endOfWeek(focusedDate, { weekStartsOn: 1 })
        : endOfMonth(focusedDate)
  return {
    startDate: format(start, 'yyyy-MM-dd'),
    endDate: format(end, 'yyyy-MM-dd'),
  }
}

/** Inclusive list of yyyy-MM-dd date strings between two ISO date strings. */
export function getDatesInRange(start: string, end: string): string[] {
  const startD = parseISO(start)
  const endD = parseISO(end)
  if (endD < startD) return []
  const out: string[] = []
  let d = startD
  while (d <= endD) {
    out.push(format(d, 'yyyy-MM-dd'))
    d = addDays(d, 1)
  }
  return out
}
